import { Alert as NativeBaseAlert, IAlertProps, IIconProps, Text } from 'native-base'
import React, { PropsWithChildren, useEffect, useRef } from 'react'
import { View } from 'react-native'

import { focusableRef } from '../../util/focus'

type AlertProps = IAlertProps & {
  children: React.ReactNode
  autofocus?: boolean
  _icon?: IIconProps
}

export const Alert: React.FC<PropsWithChildren<AlertProps>> = ({ children, autofocus = false, ...rest }) => {
  const ref = useRef<View>()
  const hasChildren = Boolean(children)

  useEffect(() => {
    if (hasChildren && autofocus) {
      try {
        focusableRef(ref)?.current?.focus()
      } catch (err) {
        console.error('Failed to focus Alert ref', err, ref)
      }
    }
  }, [hasChildren, autofocus])

  if (!hasChildren) {
    return null
  }

  return (
    <NativeBaseAlert
      accessibilityRole="alert"
      justifyContent="flex-start"
      flexDirection="row"
      w="100%"
      focusable={false}
      ref={ref}
      {...rest}
    >
      <NativeBaseAlert.Icon mr="4" accessibilityLabel="warning" />
      <Text fontSize="xs" flexShrink={1}>
        {children}
      </Text>
    </NativeBaseAlert>
  )
}
